import React from 'react';
import { ArrowLeft, ChevronRight, MapPin } from 'lucide-react';
interface Province {
  id: string;
  name: string;
  count: number;
}
interface ProvinceListProps {
  onBack: () => void;
  onProvinceClick?: (provinceId: string) => void;
}
const provinces: Province[] = [{
  id: 'wc',
  name: 'Western Cape',
  count: 4
}, {
  id: 'kzn',
  name: 'KwaZulu-Natal',
  count: 5
}, {
  id: 'gp',
  name: 'Gauteng',
  count: 3
}];
export function ProvinceList({
  onBack,
  onProvinceClick
}: ProvinceListProps) {
  return <div className="flex flex-col space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-300" data-id="element-939">
      {/* Header Section */}
      <div className="flex flex-col space-y-2" data-id="element-940">
        <button onClick={onBack} className="group flex w-fit items-center text-sm font-medium text-[#5a7280] hover:text-[#062133] transition-colors min-h-[44px] px-2 -ml-2 rounded-lg hover:bg-[#062133]/5" aria-label="Back to dashboard" data-id="element-941">
          <ArrowLeft className="mr-1 h-4 w-4 transition-transform group-hover:-translate-x-1" data-id="element-942" />
          Back to Dashboard
        </button>

        <div className="flex items-center justify-between" data-id="element-943">
          <div data-id="element-944">
            <h2 className="text-2xl font-bold text-[#062133]" data-id="element-945">
              Sites Flagged for Optimisation
            </h2>
            <p className="text-[#5a7280]" data-id="element-946">Breakdown by province</p>
          </div>
        </div>
      </div>

      {/* Province List Card */}
      <div className="overflow-hidden rounded-xl border border-[#e5e5e5] bg-white shadow-sm" data-id="element-947">
        <div className="divide-y divide-[#e5e5e5]" data-id="element-948">
          {provinces.map(province => <button key={province.id} onClick={() => onProvinceClick?.(province.id)} className="group flex w-full items-center justify-between p-5 text-left transition-all hover:bg-[#fafaf9] focus:outline-none focus:bg-[#fafaf9] min-h-[72px]" data-id="element-949">
              <div className="flex items-center gap-4" data-id="element-950">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#062133]/5 text-[#062133]" data-id="element-951">
                  <MapPin className="h-5 w-5" data-id="element-952" />
                </div>
                <div data-id="element-953">
                  <span className="block text-lg font-semibold text-[#062133]" data-id="element-954">
                    {province.name}
                  </span>
                  <span className="text-sm text-[#5a7280]" data-id="element-955">View details</span>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-956">
                <span className="inline-flex items-center rounded-full bg-amber-500/10 px-3 py-1 text-sm font-medium text-amber-600" data-id="element-957">
                  {province.count} sites
                </span>
                <ChevronRight className="h-5 w-5 text-[#e5e5e5] transition-colors group-hover:text-[#062133]" data-id="element-958" />
              </div>
            </button>)}
        </div>
      </div>
    </div>;
}